import React from 'react';
import { compose } from 'redux';
import {
  useTranslation,
  withTranslation,
  WithTranslation,
} from 'react-i18next';
import Zone from '@wix/da-gruser-shared/pkg/components/Zone';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import { useDispatch } from 'react-redux';
import { getShopWidgetConfigs } from '../shopWidgetConfigs';
import EmptyState from '../_partials/EmptyState';
import OwnerProfileShopAd from '@wix/da-shared-react/pkg/DealerAd/Placement/OwnerProfileShop';

import s from './ShopAll.scss';

export interface Props {
  className?: string;
  isEmpty?: boolean;
  isOwner?: boolean;
  hasSingularContentType?: boolean;
  emptySections?: Object;
}

const defaultProps = {};

const enhance = compose(withSectionFetchSpinner, withTranslation());

const ShopAll: React.FC<Props & WithTranslation> = ({
  isEmpty,
  isOwner,
  className,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const shopWidgetConfigs = getShopWidgetConfigs({ t, dispatch });

  if (isEmpty && !isOwner) {
    return <EmptyState view="large" />;
  }

  // deviation_gruser TODO:
  // if there is only one section and it's not empty, we want to expand it
  // to visitors to show more thumbs immediately
  // const expandOnlySection =
  //   !isOwner && hasSingularContentType && emptySections;

  return (
    <div className={className}>
      {isOwner && (
        <div className={s['ad']}>
          <OwnerProfileShopAd />
        </div>
      )}
      <Zone
        name="topBar"
        className={s['zone']}
        widgetConfigs={shopWidgetConfigs}
      />
    </div>
  );
};

ShopAll.defaultProps = defaultProps;

export default enhance(ShopAll);
